import { useQuery } from "@tanstack/react-query";
import { fetchRevisionsByDate } from "@/lib/services/revisionsService";

/**
 * React Query hook for fetching today's revisions with 1-minute polling.
 * @param enabled - Whether the query should run (default: true)
 */
export function useRevisions(enabled = true) {
    const today = new Date().toISOString().split('T')[0]; // YYYY-MM-DD
    return useQuery({
        queryKey: ["revisions", today],
        queryFn: () => fetchRevisionsByDate(today),
        staleTime: 30 * 1000,       // 30 seconds
        refetchInterval: 60 * 1000, // Poll every 1 minute
        enabled,
    });
}
